<template>
  <form @submit.prevent="submit">
    <b-row>
      <b-col>
        <b-card>
          <fields ungrouped />
        </b-card>
      </b-col>
    </b-row>
    <div class="form-group">
      <b-button type="submit" variant="primary">
        {{ $t('general.save') }}
      </b-button>
      <b-button type="button" variant="light" class="ml-2" @click="cancel">
        {{ $t('general.cancel') }}
      </b-button>
    </div>
  </form>
</template>

<script>
import { ResourceFormMixin } from 'stylemix-vue-admin'
import CouponsApi from './CouponsApi'

export default {
  name: 'CouponsForm',

  mixins: [ResourceFormMixin],

  data() {
    return {
      base: 'coupons',
    }
  },

  mounted() {
    this.loadForm()
  },

  methods: {
    api() {
      return new CouponsApi()
    },
    submit() {
      this.save()
    },
  },
}
</script>
